import "./content-slider2.css";

const ContentSlider2 = () => {
  return (
    <div className="content-slider-section2">
      <div className="content-slider2">
        <div className="content-slider-content2">
          <h1>Environment</h1>
        </div>
        <div className="content-slider-content2">
          <h1>*</h1>
        </div>
        <div className="content-slider-content2">
          <h1>Recycling</h1>
        </div>
        <div className="content-slider-content2">
          <h1>*</h1>
        </div>
        <div className="content-slider-content2">
          <h1>Renewable</h1>
        </div>
        <div className="content-slider-content2">
          <h1>*</h1>
        </div>
      </div>
      <div className="content-slider2">
        <div className="content-slider-content2">
          <h1>Environment</h1>
        </div>
        <div className="content-slider-content2">
          <h1>*</h1>
        </div>
        <div className="content-slider-content2">
          <h1>Recycling</h1>
        </div>
        <div className="content-slider-content2">
          <h1>*</h1>
        </div>
        <div className="content-slider-content2">
          <h1>Renewable</h1>
        </div>
        <div className="content-slider-content2">
          <h1>*</h1>
        </div>
      </div>
    </div>
  );
};

export default ContentSlider2;
